import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Leaf } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-nh-deep text-nh-cream">
      <div aria-hidden="true" className="flex h-1 w-full">
        <span className="w-1/3 bg-nh-green" />
        <span className="w-1/3 bg-nh-blue" />
        <span className="w-1/3 bg-nh-gold" />
      </div>
      <Leaf
        className="pointer-events-none absolute -right-10 -top-10 h-56 w-56 text-nh-fresh/10"
        strokeWidth={1}
      />
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img
              src="/logo.png"
              alt="Nurturing Happiness logo"
              className="h-20 w-20 rounded-full object-contain"
            />
            <p className="mt-5 font-heading text-2xl font-semibold">Nurturing Happiness</p>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-nh-cream/75">
              Nurturing minds. Empowering learning. Building happier communities.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-nh-fresh">Explore</h3>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link data-testid="footer-link-home" to="/" className="text-nh-cream/80 transition-colors hover:text-nh-yellow">Home</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="text-nh-cream/80 transition-colors hover:text-nh-yellow">About Us</Link></li>
              <li><Link data-testid="footer-link-what-we-do" to="/what-we-do" className="text-nh-cream/80 transition-colors hover:text-nh-yellow">What We Do</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="text-nh-cream/80 transition-colors hover:text-nh-yellow">Contact Us</Link></li>
              <li><Link data-testid="footer-link-article" to="/10-tips-for-better-education" className="text-nh-cream/80 transition-colors hover:text-nh-yellow">10 Tips for Better Education</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-nh-fresh">Contact</h3>
            <ul className="mt-5 space-y-4 text-sm text-nh-cream/80">
              <li className="flex gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-nh-yellow" />
                <span data-testid="footer-address">
                  2nd Floor, Nishant Tower, MG Road<br />
                  Akola, Maharashtra – 444001, India
                </span>
              </li>
              <li className="flex gap-3">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-nh-yellow" />
                <a data-testid="footer-phone" href="tel:+919921193939" className="transition-colors hover:text-nh-yellow">
                  +91 99211 93939
                </a>
              </li>
              <li className="flex gap-3">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-nh-yellow" />
                <a
                  data-testid="footer-email"
                  href="mailto:nurturinghappiness2@gmail.com"
                  className="break-all transition-colors hover:text-nh-yellow"
                >
                  nurturinghappiness2@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-nh-fresh">Legal</h3>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link data-testid="footer-link-privacy" to="/privacy-policy" className="text-nh-cream/80 transition-colors hover:text-nh-yellow">Privacy Policy</Link></li>
              <li><Link data-testid="footer-link-terms" to="/terms-and-conditions" className="text-nh-cream/80 transition-colors hover:text-nh-yellow">Terms &amp; Conditions</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-7">
          <p data-testid="footer-copyright" className="text-center text-sm text-nh-cream/60">
            © 2026 Aditi Rishikesh Pohare. All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
